module.exports = __webpack_public_path__ + "bin/87c855c97b13293964c3051e1ddcb2ab.jpg";